import { EServiceTypes } from '../../repositories/billing-tariffs/entities/PublishTerms/AvailableServiceCosts';
import { EServices } from '../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';
import { EServiceId, EServiceType } from '../../types/reducers/publishTerms';

/**
 * Использовать только в слое маппинга данных.
 * Если хочешь использовать в слоях ниже, значит что-то пошло не так,
 * поскольку сущности в сторе должны быть уже нормализованными, с полем serviceId
 */
export function getServiceId(serviceTypes: Array<EServices | EServiceType | EServiceTypes>): EServiceId {
  return serviceTypes.join('+') as EServiceId;
}
